module.exports = __webpack_public_path__ + "img/asso_jinair_mo.438b2c26.jpg";